import React from "react";

export const ActionCard = ({ onOpenModal }) => {
	const handleOpenModal = () => {
		onOpenModal(true);
	};

	return (
		<div className="w-full p-4 text-center bg-white border border-gray-200 rounded-lg shadow-sm sm:p-8 dark:bg-gray-800 dark:border-gray-700">
			<h5 className="mb-2 text-3xl font-bold text-gray-900 dark:text-white">You shouldn't be the only one promoting your music</h5>
			<p className="mb-5 text-base text-gray-500 sm:text-lg dark:text-gray-400">
				Start building your list of promoters. Think of them as your street team. <br />
				We're talking DJs, Playlist Owners, Media, etc.
			</p>
			<div className="items-center justify-center space-y-4 sm:flex sm:space-y-0 sm:space-x-4 rtl:space-x-reverse">
				<button
					onClick={handleOpenModal}
					type="button"
					className="border text-red-400 hover:text-red-500 border-red-400 font-medium rounded-lg text-sm px-4 py-2 me-2 mb-2">
					Add Your First Promoter
				</button>
			</div>
			<br />
			<p className="mb-5 text-base text-gray-500 sm:text-lg dark:text-gray-400">
				<span className="text-transparent font-bold bg-clip-text bg-gradient-to-r to-red-400 from-red-500">PRO TIP</span>: Leverage Ava to
				help find promoters for your genre of music!
			</p>
		</div>
	);
};
